import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { Header } from "@pentabd/ui";
import { IconUsers01 } from "@pentabd/icons";

import { ROUTES } from "@constants/routes";

const {
  HRM: { POSITIONS },
} = ROUTES;

export const ModifyPositionPageHeader = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconUsers01 fill="dark" size="20" />,
    },
    {
      label: t("POSITION.CREATE.BREADCRUMBS.FIRST_STEP"),
      link: POSITIONS,
    },
    {
      label: t(`POSITION.${id ? "EDIT" : "CREATE"}.BREADCRUMBS.SECOND_STEP`),
    },
  ];

  const headerText = {
    header: t(`POSITION.${id ? "EDIT" : "CREATE"}.LABEL`),
    subHeader: t(`POSITION.${id ? "EDIT" : "CREATE"}.DESCRIPTION`),
  };

  return <Header breadcrumbs={breadcrumbs} headerText={headerText} />;
};
